import { DESIGN_AREA_ID, isDesignTaskVisibleToUser } from './access';
import type { DepartmentTask, ZenBootstrap } from './types';

export function availableWorkForUser(data: ZenBootstrap): DepartmentTask[] {
  if (data.currentUser.isAdmin) return [];

  const queueIds = new Set(
    data.departments
      .filter((department) => (
        department.active
        && department.queueEnabled
        && data.currentUser.departmentIds.includes(department.id)
      ))
      .map((department) => department.id),
  );
  const orders = new Map(data.workOrders.map((order) => [order.id, order]));

  return data.tasks.filter((task) => {
    if (!queueIds.has(task.departmentId) || task.status !== 'pending' || !task.availableAt) return false;
    if (task.departmentId !== DESIGN_AREA_ID) return true;
    return isDesignTaskVisibleToUser(
      task,
      orders.get(task.workOrderId)?.contactPerson,
      data.currentUser,
    );
  });
}

export function newlyAvailableWork(
  previousTaskIds: ReadonlySet<string>,
  data: ZenBootstrap,
): DepartmentTask[] {
  return availableWorkForUser(data).filter((task) => !previousTaskIds.has(task.id));
}

export function workNotificationMessage(tasks: DepartmentTask[], data: ZenBootstrap): string {
  if (tasks.length === 1) {
    const task = tasks[0];
    const order = data.workOrders.find((item) => item.id === task.workOrderId);
    const work = [order?.orderNumber, task.itemDescription].filter(Boolean).join(' — ');
    return `New ${task.departmentName} work is ready${work ? `: ${work}` : ''}`;
  }

  const departments = [...new Set(tasks.map((task) => task.departmentName))].join(', ');
  return `${tasks.length} new pieces of work are ready${departments ? ` in ${departments}` : ''}`;
}

let notificationAudio: HTMLAudioElement | null = null;

export function playWorkNotificationSound(): void {
  if (typeof window === 'undefined') return;
  try {
    notificationAudio ??= new Audio(`${import.meta.env.BASE_URL}universfield-message-ping-351298.mp3`);
    notificationAudio.preload = 'auto';
    notificationAudio.volume = 0.65;
    notificationAudio.currentTime = 0;
    void notificationAudio.play().catch(() => {
      // Audio can be blocked until the browser has received a user gesture.
    });
  } catch {
    // Audio can be blocked until the browser has received a user gesture.
  }
}
